const e = {
  data() {
    return {
      hoverOption: -1
    };
  },
  computed: {
    optionsAllDisabled() {
      return this.options.filter((i) => i.visible).every((i) => i.disabled);
    }
  },
  watch: {
    hoverIndex(i) {
      typeof i == "number" && i > -1 && (this.hoverOption = this.options[i] || {}), this.options.forEach((t) => {
        t.hover = this.hoverOption === t;
      });
    }
  },
  methods: {
    navigateOptions(i) {
      if (!this.visible) {
        this.visible = !0;
        return;
      }
      if (!(this.options.length === 0 || this.filteredOptionsCount === 0) && !this.optionsAllDisabled) {
        i === "next" ? (this.hoverIndex++, this.hoverIndex === this.options.length && (this.hoverIndex = 0)) : i === "prev" && (this.hoverIndex--, this.hoverIndex < 0 && (this.hoverIndex = this.options.length - 1));
        const t = this.options[this.hoverIndex];
        (t.disabled === !0 || t.groupDisabled === !0 || !t.visible) && this.navigateOptions(i), this.$nextTick(() => this.scrollToOption(this.hoverOption));
      }
    }
  }
};
export {
  e as default
};
